import { StrictMode } from 'react'
import './i18n'
import { createRoot, hydrateRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { preloadPage } from './pages/lazyPages'

const root = document.getElementById('root')!;
const app = <StrictMode><App /></StrictMode>;
if (root.dataset.prerendered === 'true') hydrateRoot(root, app);
// A static snapshot (legal, team and CityLab pages) stays on screen until the
// page's own code is here; then React replaces it with the live page.
else if (root.dataset.static === 'true') preloadPage(window.location.pathname).catch(() => {}).then(() => createRoot(root).render(app));
else createRoot(root).render(app);

/*
  Register the product's service worker from here too.

  A browser will not offer to install a site unless a service worker with a
  fetch handler controls the page it is looking at. The product registers one at
  the origin root and the landing page did not register anything, so a visitor
  whose first page was the landing page had no worker controlling it, no install
  prompt was ever fired, and the install button could not appear. Everyone who
  had reached /app first got one; everyone arriving at the front door did not.

  It is the same file the product serves, at the same origin, with scope "/", so
  this adds a registration rather than a second worker. It leaves the landing
  page alone: navigations here are read from the network and deliberately kept
  out of its offline shell, and it never caches JavaScript or CSS at all.
*/
if ('serviceWorker' in navigator && window.location.protocol === 'https:') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch(() => {
      // No worker means no install prompt, which the button already handles by
      // showing how to install by hand instead.
    });
  });
}
